<template>
  <div>
    <LDBsTable
      url="os"
      defaultSort="status"
      defaultOrder="asc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions='options'
    >
      <div class="form-group col-lg-4">
        <label for="os_number">{{ $t('os_number') }}</label>
        <input
          type="text"
          id="os_number"
          name="os_number"
          class="form-control"
          :placeholder="$t('ph_os_number')"
          v-model="query.number"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="status">{{ $t('status') }}</label>
        <Combobox
          :disabled="query.generateBilling"
          class="bg-white"
          name='status'
          :placeholder="$t('select_a_item')"
          :options="os.statusOsTests"
          :initial-value="query.status"
          label="name"
          v-model="query.status"
          :reduce="status => status.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
        <Combobox
          class="bg-white"
          name='garage_accredited'
          :placeholder="$t('select_a_item')"
          :options="os.garages"
          :initial-value="query.garageAccredited"
          label="fantasyName"
          v-model="query.garageAccredited"
          :reduce="garage => garage.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="serial">{{ $t('new_equipment') }}</label>
        <input
          type="text"
          id="serial"
          name="serial"
          class="form-control"
          :placeholder="$t('ph_new_equipment')"
          v-model="query.serial"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="serial">{{ $t('old_equipment') }}</label>
        <input
          type="text"
          id="withdrawnSerial"
          name="withdrawnSerial"
          class="form-control"
          :placeholder="$t('ph_old_equipment')"
          v-model="query.withdrawnSerial"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="contract">{{ $t('contract') }}</label>
        <Combobox
          class="bg-white"
          name='contract'
          :placeholder="$t('select_a_item')"
          :options="os.contracts"
          :initial-value="query.contract"
          label="contracts"
          v-model="query.contract"
          :reduce="contract => contract.id_contrato"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="board">{{ $t('board') }}</label>
        <input
          type="text"
          id="board"
          name="board"
          class="form-control"
          :placeholder="$t('ph_board')"
          v-model="query.board"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="vehicleType">{{ $t('vehicle_type') }}</label>
        <Combobox
          class="bg-white"
          name='vehicle_type'
          :placeholder="$t('select_a_item')"
          :options="os.vehicleTypes"
          :initial-value="query.vehicleType"
          label="TPV_DSC"
          v-model="query.vehicleType"
          :reduce="vehicleType => vehicleType.TPV_COD"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="services">{{ $t('services') }}</label>
        <Combobox
          class="bg-white"
          name='services'
          :placeholder="$t('select_a_item')"
          :options="os.serviceTypes"
          :initial-value="query.services"
          label="name"
          v-model="query.services"
          :reduce="serviceType => serviceType.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="reason">{{ $t('reason') }}</label>
        <Combobox
          class="bg-white"
          name='reason'
          :placeholder="$t('select_a_item')"
          :options="os.maintanceReasons"
          :initial-value="query.maintanceReason"
          label="name"
          v-model="query.maintanceReason"
          :reduce="maintanceReason => maintanceReason.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="period_start">{{ $t('period_start') }} (Teste)</label>
        <input
          type="date"
          id="period_start"
          name="period_start"
          class="form-control"
          :placeholder="$t('ph_period_start')"
          v-model="query.testDateStart"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="period_end">{{ $t('period_end') }} (Teste)</label>
        <input
          type="date"
          id="period_end"
          name="period_end"
          class="form-control"
          :placeholder="$t('ph_period_end')"
          v-model="query.testDateEnd"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="problems_found">{{ $t('problems_found') }}</label>
        <input
          type="text"
          id="problems_found"
          name="problems_found"
          class="form-control"
          :placeholder="$t('ph_problems_found')"
          v-model="query.msgFinish"
        >
      </div>

      <div class="switch form-group col-lg-4">
        <label for="generateBilling">{{ $t('generate_billing') }}</label>
        <div class="onoffswitch2">
          <input
            type="checkbox"
            class="onoffswitch2-checkbox"
            id="generateBilling"
            v-model="query.generateBilling"
          >

          <label class="onoffswitch2-label" for="generateBilling">
            <span class="onoffswitch2-inner"></span>
            <span class="onoffswitch2-switch"></span>
          </label>
        </div>
      </div>

      <div class="switch form-group col-lg-4" v-show="query.generateBilling">
        <label for="showBillingEmitted">{{ $t('show_billing_emitted') }}</label>
        <div class="onoffswitch2">
          <input
            type="checkbox"
            class="onoffswitch2-checkbox"
            id="showBillingEmitted"
            v-model="query.showBillingEmitted"
          >

          <label class="onoffswitch2-label" for="showBillingEmitted">
            <span class="onoffswitch2-inner"></span>
            <span class="onoffswitch2-switch"></span>
          </label>
        </div>
      </div>
    </LDBsTable>

    <!-- MODAL DELETE OS -->
    <div class="modal fade" id="modalDeleteOs" tabindex="-1" role="dialog" aria-labelledby="modalDeleteOsLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalDeleteOsLabel">Cancelar OS</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h3 id="msgConfirmOs"></h3>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('close') }}</button>
            <button type="button" class="btn btn-danger" @click="deleteOs" data-dismiss="modal">{{ $t('yes') }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL CHANGE CONTRACT OR REASON -->
    <div class="modal fade" id="modalChangeContractOrReason" tabindex="-1" role="dialog" aria-labelledby="modalChangeContractOrReasonLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalChangeContractOrReasonLabel">Editar Contrato e/ou Motivo</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group" v-if="!loading">
              <label for="contractToUpdate">{{ $t('contract') }}</label>
              <Combobox
                class="bg-white"
                name='contractToUpdate'
                :placeholder="$t('select_a_item')"
                :options="os.contracts"
                :initial-value="dataToUpdate.contract"
                label="contracts"
                v-model="dataToUpdate.contract"
                :reduce="contract => contract.id_contrato"
              />
            </div>

            <div class="form-group" v-if="!loading && (dataToUpdate.service === 2 || dataToUpdate.service === 6)">
              <label for="reasonToUpdate">{{ $t('reason') }}</label>
              <Combobox
                class="bg-white"
                name='reasonToUpdate'
                :placeholder="$t('select_a_item')"
                :options="os.maintanceReasons"
                :initial-value="dataToUpdate.reason"
                label="name"
                v-model="dataToUpdate.reason"
                :reduce="maintanceReason => maintanceReason.id"
              />
            </div>

            <div class="d-flex justify-content-center mb-3" v-if="loading">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t('close') }}
            </button>

            <button
              type="button"
              class="btn btn-primary"
              @click="updateOs"
            >
              {{ $t('save') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL CONFIRM BILLING -->
    <div class="modal fade" id="modalConfirmBilling" tabindex="-1" role="dialog" aria-labelledby="modalConfirmBillingLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalConfirmBillingLabel">Confirmar emissão de cobrança</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul>
              <li>
                OS: <strong>{{ osDataToMarkWithBillingEmitted.id }}</strong>
              </li>
              <li>
                PLACA: <strong>{{ osDataToMarkWithBillingEmitted.board }}</strong>
              </li>
              <li>
                CONTRATO: <strong>{{ osDataToMarkWithBillingEmitted.contract }}</strong>
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              :disabled="isLoading"
            >
              {{ $t('close') }}
            </button>

            <LoaderButton
              class="mt-3"
              @click="confirmBillingEmitted"
              :loading="isLoading"
            >
              {{ $t('confirm') }}
            </LoaderButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import LoaderButton from '@/components/button/LoaderButton'
import { request } from '@/lib/http'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'OsList',
  components: {
    LDBsTable,
    Combobox,
    LoaderButton
  },

  data () {
    return {
      idOsToDelete: undefined,
      columns: [
        {
          title: this.$t('os'),
          field: 'id',
          width: '50%',
          sortable: true
        },
        {
          title: this.$t('status'),
          field: 'status',
          sortable: true,
          formatter: value => {
            if (value === 1) return 'Aguardando'
            if (value === 2) return 'Cancelado'
            if (value === 3) return 'Concluído'
          }
        },
        {
          title: this.$t('garage_accredited'),
          field: 'garageAccredited',
          formatter: function(value) {
            if (!value) {
              return '-'
            }

            const info = [value.fantasyName]

            const city = _.get(value, 'city', '')
            const uf = _.get(value, 'uf', '')

            city && info.push(city.toUpperCase())
            uf && info.push(uf.toUpperCase())

            return info.join(' - ')
          },
          sortable: true
        },
        {
          title: this.$t('new_equipment'),
          field: 'serial',
          sortable: true
        },
        {
          title: this.$t('old_equipment'),
          field: 'withdrawnSerial',
          formatter: function(value) {
            return value
              ? value
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('contract'),
          field: 'contract',
          formatter: function(value) {
            return value.contracts
          },
          sortable: true
        },
        {
          title: this.$t('board'),
          field: 'board',
          sortable: true,
          formatter: value => {
            return value.length === 7
              ? value.substr(0,3)+"-"+value.substr(3,7)
              : value
          }
        },
        {
          title: this.$t('vehicle_type'),
          field: 'vehicleType',
          formatter: function(value) {
            return value.TPV_DSC
          },
          visible: false,
          sortable: true
        },
        {
          title: this.$t('services'),
          field: 'services',
          formatter: function(value) {
            return value.name
          },
          sortable: true
        },
        {
          title: this.$t('reason'),
          field: 'maintanceReason',
          formatter: function(value) {
            return value
              ? value.name
              : '-'
          },
          visible: false,
          sortable: true
        },
        {
          title: this.$t('problems_found'),
          field: 'msgFinish',
          formatter: function(value) {
            if (value) {
              const arr = JSON.parse(value)
              return arr.map(e => { return ' ' + e })
            }
          },
          visible: false,
          sortable: true
        },
        {
          title: this.$t('finished_in'),
          field: 'testDate',
          formatter: value => value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '',
          visible: false
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '120px',
          formatter: function (value, row) {
            if (row.status != 1) {
              let buttons = `
                <a
                  href="#/main/os/preview/${value}"
                  title="Visualizar"
                  class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
                >
                  <i class="fas fa-eye" />
                </a>
              `

              if (row.status == 3) {
                buttons += `
                  <button
                    title="Alterar Contrato e/ou Motivo"
                    data-target="#modalChangeContractOrReason"
                    data-id='${value}'
                    data-toggle="modal"
                    data-whatever="${row.services.id}"
                    class="mb-1 btn btn-action btn-warning btn-circle light-bottom-shadow text-white">
                    <i class="fas fa-pen" />
                  </button>
                `

                if (row.generateBilling) {
                  const isEmitted = row.billingEmitted;
                  const title = isEmitted ? "Cobrança emitida" : "Marcar cobrança como emitida";
                  const btnClass = isEmitted ? "btn-secondary" : "btn-danger";
                  const disabledAttr = isEmitted ? "disabled" : "";

                  buttons += `
                    <button
                      title="${title}"
                      data-target="#modalConfirmBilling"
                      data-id="${value}"
                      data-toggle="modal"
                      data-whatever-id="${row.id}"
                      data-whatever-board="${row.board}"
                      data-whatever-contract="${row.contract.contracts}"
                      class="mb-1 btn btn-action ${btnClass} btn-circle light-bottom-shadow text-white"
                      ${disabledAttr}>
                      <i class="fas fa-file-invoice-dollar fa-lg"></i>
                    </button>
                  `
                }
              }

              return buttons
            }

            return `
              <a
                href="#/main/os/edit/${value}"
                title="Editar"
                class="edit mb-1 btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-pen" />
              </a>
              <button
                title="Cancelar"
                data-target="#modalDeleteOs"
                data-id='${value}'
                data-toggle="modal"
                data-whatever="${value}"
                data-name='os${value}'
                class="mb-1 btn btn-action btn-danger btn-circle light-bottom-shadow text-white">
                <i class="fas fa-ban fa-lg" />
              </button>
            `
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'OS' }
      },
      query: {
        id: '',
        number: '',
        garageAccredited: '',
        serial: '',
        withdrawnSerial: undefined,
        contract: '',
        board: '',
        vehicleType: '',
        services: '',
        maintanceReason: '',
        status: 1,
        msgFinish: '',
        testDateStart: '',
        testDateEnd: '',
        generateBilling: false,
        showBillingEmitted: false
      },
      dataToUpdate: {
        id      : undefined,
        contract: undefined,
        reason  : undefined,
        service : undefined
      },
      loading: false,
      queryToUse: {},
      osDataToMarkWithBillingEmitted: {
        id: undefined,
        board: undefined,
        contract: undefined
      }
    }
  },

  watch: {
    'query.generateBilling'(value) {
      this.query.id = '',
      this.query.number = '',
      this.query.garageAccredited = '',
      this.query.serial = '',
      this.query.withdrawnSerial = undefined,
      this.query.contract = '',
      this.query.board = '',
      this.query.vehicleType = '',
      // this.query.services = value ? 1 : '',
      this.query.maintanceReason = '',
      this.query.status = value ? 3 : 1,
      this.query.msgFinish = '',
      this.query.testDateStart = '',
      this.query.testDateEnd = ''
    }
  },

  computed: {
    ...mapState({
      os: state => state.os.all,
      isLoading: state => state.os.loading,
      lastquery: state => state.filtershistory.query
    })
  },

  methods: {
    ...mapActions('os', [ 'inactivate', 'cleanState' ]),

    clear() {
      this.query.number = undefined
      this.query.garageAccredited = undefined
      this.query.serial = ''
      this.query.withdrawnSerial = undefined
      this.query.contract = ''
      this.query.board = ''
      this.query.vehicleType = ''
      this.query.services = ''
      this.query.maintanceReason = ''
      this.query.status = ''
      this.query.msgFinish = ''
      this.query.testDateStart = ''
      this.query.testDateEnd = ''
      this.query.generateBilling = false
    },

    async deleteOs() {
      const result = await this.inactivate(this.idOsToDelete)

      result
        ? $("#search").trigger("click")
        : this.$store.dispatch('notify/error', { message: this.$t('errorToRemoveOs') }, { root: true })

    },

    async updateOs() {
      this.loading = true

      try {
        await request({
          url   : `edit-contract-or-reason-os-finished/${this.dataToUpdate.id}`,
          method: 'patch',
          data  : this.dataToUpdate
        })

        $('#modalChangeContractOrReason').modal('hide')
        $("#search").trigger("click")
      } catch (error) {
        this.$store.dispatch('notify/error', error)
      } finally {
        this.loading = false
      }
    },

    async loadContractAndReason(idOs, service) {
      this.dataToUpdate.id      = idOs
      this.dataToUpdate.service = service

      this.loading = true

      try {
        const data = await request({
          url: `get-contract-and-reason/${idOs}`,
          method: 'get'
        })

        this.dataToUpdate.contract = data.contract
        this.dataToUpdate.reason = data.maintanceReason
      } catch (error) {

      } finally {
        this.loading = false
      }
    },

    async confirmBillingEmitted() {
      await this.$store.dispatch(
        'os/confirmBillingEmitted',
        { os: this.osDataToMarkWithBillingEmitted.id }
      )

      $('#modalConfirmBilling').modal('hide')
      $("#search").trigger("click")
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['oslist'] ? this.lastquery['oslist'] : this.query
  },

  async mounted () {
    const { dispatch } = this.$store

    dispatch('overlay/show', true)
    await dispatch('os/fetchAllPageOsList')

    if (this.lastquery['oslist']) {
      for (const [key, value] of Object.entries(this.lastquery['oslist'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query

    const global = this

    $('#modalDeleteOs').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      const modal = $(this)
      modal.find('#msgConfirmOs').text(`Deseja cancelar OS ${button.data('whatever')}?`)
      global.idOsToDelete = button.data('whatever')
    })

    $('#modalDeleteOs').on('hide.bs.modal', function (event) {
      global.idOsToDelete = undefined
    })

    $('#modalChangeContractOrReason').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)

      global.loadContractAndReason(button.data('id'), button.data('whatever'))
    })

    $('#modalChangeContractOrReason').on('hide.bs.modal', function (event) {
      global.dataToUpdate = {
        id      : undefined,
        contract: undefined,
        reason  : undefined,
        service : undefined
      }
    })

    $('#modalConfirmBilling').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)

      global.osDataToMarkWithBillingEmitted = {
        id: button.data('whatever-id'),
        board: button.data('whatever-board'),
        contract: button.data('whatever-contract')
      }
    })

    $('#modalConfirmBilling').on('hide.bs.modal', function (event) {
      global.osDataToMarkWithBillingEmitted = {
        id: undefined,
        board: undefined,
        contract: undefined
      }
    })

    dispatch('overlay/show', false)
  },

  destroyed () {
    const { dispatch } = this.$store

    dispatch('maintancereason/cleanState'),
    dispatch('contracts/cleanState'),
    dispatch('vehicletypes/cleanState'),
    dispatch('garageaccredited/cleanState'),
    dispatch('servicetypes/cleanState'),
    dispatch('statusostests/cleanState'),
    dispatch('os/cleanState')
    dispatch('filtershistory/setQuery', { key: 'oslist', query: this.query })
  }
}
</script>
